import DefaultConfiguration from './default.js';
import LocalConfiguration from './local.js';

class Configuration {

  static async load() {

    return Configuration.get();

  }

  static get() {

    if (window.location.href.indexOf('localhost') === -1) {
      return DefaultConfiguration;
    }

    return LocalConfiguration;

  }

}

export default Configuration;